import { createRouter, createWebHistory } from 'vue-router';

import { useAuthStore } from '@/stores/auth.js';

/**
 * Структура роутинга:
 *   - / — публичный лендинг (bare, без AppShell)
 *   - /login, /auth/callback — bare
 *   - /app — дашборд после входа (редирект по роли внутри HomePage)
 *   - /admin/* — для администратора (Ф2+)
 *   - /access-denied — залогинен, но доступа нет
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'landing',
      component: () => import('@/pages/LandingPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/RegisterPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('@/pages/AuthCallbackPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/join/:token',
      name: 'join',
      component: () => import('@/pages/JoinPage.vue'),
      meta: { bare: true },
    },
    {
      path: '/app',
      name: 'home',
      component: () => import('@/pages/HomePage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/access-denied',
      name: 'access-denied',
      component: () => import('@/pages/AccessDeniedPage.vue'),
      meta: { requiresAuth: true },
    },

    // --- Заявки (координатор + общий просмотр) ---
    {
      path: '/app/applications',
      name: 'my-applications',
      component: () => import('@/pages/coordinator/MyApplicationsPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/app/applications/:id',
      name: 'application',
      component: () => import('@/pages/ApplicationDetailPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/region',
      name: 'region',
      component: () => import('@/pages/region/RegionDashboardPage.vue'),
      meta: { requiresAuth: true },
    },

    // --- Админка ---
    {
      path: '/admin/projects',
      name: 'admin-projects',
      component: () => import('@/pages/admin/ProjectsListPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/projects/:id',
      name: 'admin-project',
      component: () => import('@/pages/admin/ProjectEditorPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/applications',
      name: 'admin-applications',
      component: () => import('@/pages/admin/ApplicationsAdminPage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },

    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'landing' },
    },
  ],
});

router.beforeEach((to) => {
  const auth = useAuthStore();

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'login', query: { returnTo: to.fullPath } };
  }
  if (to.name === 'login' && auth.isAuthenticated) {
    return { name: 'home' };
  }
  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: 'access-denied' };
  }
  return true;
});
